module.exports = __webpack_public_path__ + "img/box-biscotti.f1184db1.png";